var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('admin-wrapper',{attrs:{"title-translation-path":"admin.activityLog.moduleTitle","module-enabler":_vm.moduleEnabler,"inputs":_vm.inputs,"has-buttons":false,"is-form-fetched":true},scopedSlots:_vm._u([{key:`table.input`,fn:function(){return [_c('activity-log-table')]},proxy:true}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }